/** Riyal amounts, in the viewer's locale (SAR / ر.س as Intl decides). */
export function formatSar(value: number | null | undefined, locale: string): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'SAR',
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * API timestamps are zone-less UTC; pin the 'Z' before parsing. A bare calendar date
 * (YYYY-MM-DD, e.g. a run_date) is a day, not an instant: build it in local time so
 * it never shifts to the previous day west of UTC.
 */
export function apiDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (dateOnly) {
    return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
  }
  const iso = /Z|[+-]\d\d:\d\d$/.test(value) ? value : `${value}Z`;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatWhen(
  value: string | null | undefined,
  locale: string,
  style: 'datetime' | 'time' | 'date' = 'datetime'
): string {
  const date = apiDate(value);
  if (!date) return '—';
  const options: Intl.DateTimeFormatOptions =
    style === 'time'
      ? { timeStyle: 'short' }
      : style === 'date'
        ? { dateStyle: 'medium' }
        : { dateStyle: 'medium', timeStyle: 'short' };
  return new Intl.DateTimeFormat(locale, options).format(date);
}

export function formatKg(value: number | null | undefined, locale: string): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value)} kg`;
}
